module.exports = __webpack_public_path__ + "img/normalLogo.89ea4d20.svg";